import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import NavBar from '../Components/NavBar';
import history from '../history'
const INPUT = styled.input`
@media screen and (min-width: 47.5rem) {
font-size: larger;
&:focus {
 border: purple;
 border-bottom: 2px solid purple;
 transition: ease-in-out 2s;
 border-radius: 3rem; 
 outline: none;

}
}
@media screen and (max-width: 47.5rem) {
font-size: large;
&:focus {
 border: purple;
 border-bottom: 2px solid purple;
 transition: ease-in-out 2s;
 border-radius: 3rem; 
 outline: none;

}
}
display: block;
margin-top: 1rem;
padding: 1.2rem;
width: 70%;
border-top-color: transparent;
border-right-color: transparent;
border-left-color: transparent;
outline: none;
transition: ease-in-out 1.5s;
align-self: center;


`
const BUTTON = styled.button`
padding: 1rem;
font-size: large;
border-radius: 3rem;
width: 70%;
font-weight: bold;
color: white;
outline: none;
border: none;
background: darkmagenta;
letter-spacing: .1rem;
cursor: pointer;
transition: ease-in-out 1.1s;
align-self: center;
&:hover {
color: black;
border: 2px solid darkmagenta;
background: white; 
transition: ease-in-out 1s;
}
@media screen and (min-width: 48rem) {
width: 35%;
}
`
 
const ChangePwd = ({match}) => {
    const[email, setE] = useState('')

    const[pass, setPas] = useState('')

    const[cpass, setCPass] = useState('')

    const[err, setErr] = useState('')

    const[show, setShow] = useState(false)
    const[Icon, setIcon] = useState(false)
    const[Type, setType] = useState('password')
    
    useEffect(() => {document.title = 'Change password'})

    const handleShowPass = () => {
        setIcon(!Icon)
        if(Type === 'password') {setType('text')} else setType('password')
    }
    const handleSubmit = async () => {

        sessionStorage.setItem('mail', email)

        try {
            if(cpass !== pass) setErr('password did not match')
            else if(cpass === pass) {
                setShow(true)
             setErr('')
             const api = `http://localhost:3001/Login/change/password/${match.params.refID}`
             
             let data = {
                email: email,
                password: pass
             }

             let init = {
                     method:'post', 
                     body:JSON.stringify(data), 
                     'headers':{'content-type':'application/json'},
                     mode:'cors'
                 }
             let res = fetch(api, init)

             let ans = await res

             let mAns = await ans.json()
            //  console.log(mAns)
             let {success, lStr, err} = mAns
            //  console.log(await ans.json())
                    //  console.log(mAns)
             if(success === 'account Success') {
                //  console.log(lStr)
                 if(lStr !== '') sessionStorage.setItem('lStr',lStr)
                
                sessionStorage.setItem('mail', email)
                // localStorage.setItem('mail', email)
                //  sessionStorage.setItem('mail', email)
                
                localStorage.removeItem('ref')
               
                sessionStorage.removeItem('ref') //remove ref from session also
                
                setTimeout(() => history.push(`/wall/${email}`) , 1100);
             }
            if(err) throw err
            } 
            
        }
         catch (error) {
             setShow(false)
             alert(`An error occurred pls retry, \n \n If it persist pls send your complains to our email, thanks`)
            // console.log(error)
        }

    }
    


    return ( 
        <>
        <NavBar
 fNav={'How To'} 
fNavL='#howWealthme' 
sNav='Home' 
sNavL='/' />
<section style={{display:'flex', flexFlow:'column', height:'100vh', justifyContent:'center', alignItems:'center'}}>

       <h2 style={{textAlign:'center', marginBottom:'3rem'}}>Iamwealthy</h2>

       <form onSubmit={e => e.preventDefault()} >

<label htmlFor='email'><strong>Email:</strong></label>
               <INPUT 
                 autoComplete='true'
                type='email' 
                style={{lineHeight: '1.5rem'}}
                placeholder='myemail@gmail.com'
                required={true}
                onChange={({target}) => setE(target.value)}
                value={match.params.emailAdd}
                 
                 />
                 <br />

<label htmlFor='text'><strong>Password:</strong></label>
            <span style={{display:'flex'}}>
                <INPUT 
                 autoComplete='true'
                type={Type} 
                style={{lineHeight: '1.5rem'}}
                placeholder='password'
                required={true}
                 onChange={({target}) => setPas(target.value)}
                 autoFocus  
                   /> <span onClick={handleShowPass} style={{alignSelf:'center', marginLeft:'1rem'}}>{Icon ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon /> }</span>
            </span>
                 <br />

<label htmlFor='Password'><strong>Confirm Passord:</strong></label>
               <INPUT 
                autoComplete='true'
                type='password' 
                style={{lineHeight: '1.5rem'}}
                placeholder='confirm password'
                required={true}
                onChange={({target}) => setCPass(target.value)}
                  />
                 <small style={{color:'red'}}>{err} </small>
                 <br />
                 <br />
 
 

       </form>
 <BUTTON type='submit' onClick={handleSubmit} style={show === true ? {display:'none'} : {display:'block'}}>Submit </BUTTON>
 

 <img src={require('../Assets/Preloaders/25.gif')} alt='confirming payment' style={show === false ? {display:'none'}: {display:'block', height: '3rem', width:'3rem'}} />  
 

   </section>

        </>
     ); 

       
}
 
export default ChangePwd;